import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Add, Filter9Plus } from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import zonesStyle from "../../assets/jss/material-dashboard-pro-react/views/zonesStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";

//Modals
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import TextFilter from "../../components/Filters/TextFilter";

class Index extends React.Component {
  state = {
    selectedIds: [],
    showDeleteAlert: false,
  };

  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  hideDeleteAlert = () => {
    this.setState({ showDeleteAlert: false });
  };

  canCreateNieuwItem = () => {
    if (this.props.vestiging_id) {
      return true;
    }
    return false;
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Zone overview"} tKey={"zones.pagetitle"} />} />
        <GridContainer>
          {this.canCreateNieuwItem() ? (
            <GridItem xs={12}>
              <Link to={"./create"}>
                <Button className={classes.marginRight} color={"success"}>
                  <Add className={classes.icons} />{" "}
                  <TranslationWrapper tDefault={"New zone"} tKey={"zones.nieuw.item"} />
                </Button>
              </Link>
            </GridItem>
          ) : null}
        </GridContainer>

        <GridContainer>
          <VestigingenFilter />
          <GridItem md={4} xs={12}>
            <TextFilter
              field={"zoneName"}
              fieldKey={"zones:zoneName"}
              operator={"like"}
              placeholder={getTranslation("zones.filter.tafel", "Filter one zonename")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "vestiging.systeemNaam", editable: false },
                { dbfield: "zoneName", editable: false },
                { dbfield: "disableTables", editable: true, inputtype: "Switch" },
                { dbfield: "zoneDescription", editable: false },
              ]}
              dbfields={"id,zoneName,zoneDescription,disableTables,vestiging_id,vestiging.id,vestiging.systeemNaam"}
              delete={"zones.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"zones/:id/edit"}
              fetchUrl={"core/zones"}
              filters={this.props.filters}
              headerIcon={<Filter9Plus />}
              headers={[
                {
                  label: getTranslation("zones.zone.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("zones.zone.vestiging", "Salesarea"),
                  sortable: true,
                  width: "20%",
                  sortKey: "vestiging.naam",
                },
                {
                  label: getTranslation("zones.zone.naam", "Naam"),
                  width: "20%",
                  sortable: true,
                  sortKey: "naam",
                },
                {
                  label: getTranslation("zones.zone.disableTables", "Disable Tables (v5)"),
                  width: "10%",
                  sortable: false,
                },
                {
                  label: getTranslation("zones.zone.descr", "Description"),
                  width: "40%",
                  sortable: false,
                },
              ]}
              multieSelect
              multieSelectHandler={this.handleMultieSelect}
              reduxKey={"zones"}
              tableTitle={<TranslationWrapper tDefault={"Zones"} tKey={"zones.zone.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);
  if (state.filtersV2["zones:zoneName"]) {
    filters["zones:zoneName"] = state.filtersV2["zones:zoneName"];
  }
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
    user_id: state.user.id,
    filters: filters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, zonesStyle));
